<template>
  <b-container fluid class="header-container">
    <b-row align-v="center">
      <b-col md="8">
        <div class="d-flex">
          <b-link v-show="showGoBack" class="ml-1 pt-3" @click="goBack" style="color: #1d58b7;">
            <font-awesome-icon :icon="['far', 'arrow-left']" size="lg" />
          </b-link>
          <div class="title-container">
            <div class="title-icon">
              <font-awesome-icon :icon="['fas', 'tools']" size="lg" fixed-width />
            </div>
            <div>
              <h1 class="title">
                {{ title }}
              </h1>
              <p class="subtitle" style="height: 21px;">
                {{ subTitle }}
              </p>
            </div>
          </div>
        </div>

      </b-col>
      <b-col md="4" class="mb-2 mb-md-0">
        <slot></slot>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
export default {
  name: 'Header',
  props: {
    title: {
      type: String,
      required: true
    },
    subTitle: {
      type: String,
      required: true
    },
    showGoBack: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    goBack () {
      if (this.$route.name === 'ServiceCallIndex') {
        this.$router.push('/')
        return
      } else if (this.$route.name === 'ServiceCallShow') {
        this.$router.push('/app/prod/llamadas-servicio')
        return
      } else if (this.$route.name === 'ServiceCallNew') {
        this.$router.push('/app/prod/llamadas-servicio')
        return
      }

      this.$router.go(-1)
    }
  }
}
</script>

<style scoped>
  .header-container {
    background: #fff;
    border-bottom: 1px solid #e5e2dc;
  }

  .title-container {
    display: flex;
    align-items: center;
    gap: 14px;
    padding: 18px 28px 16px;
  }

  .title-icon {
    width: 45px; height: 45px; flex-shrink: 0;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    background-color: #1d58b7;
    border-radius: 5px;
  }
  .title {
    font-size: 1.15rem;
    font-weight: 700;
    margin: 0
  }
  .subtitle {
    font-size: 0.875rem;
    color: #888;
    margin: 0;
  }
</style>